import { SupabaseClient } from "@supabase/supabase-js";

const SB_URL = "https://pppzrvamzfeudpbjsejg.supabase.co";
const SB_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTY0MDA5NjUzMSwiZXhwIjoxOTU1NjcyNTMxfQ._jj92jEeeQBE9L-DgzWt2ueRwuXMuyBjkpY0lhTcg6Y";

export const supabaseClient = new SupabaseClient(SB_URL, SB_KEY);
export type KnownTables = "profile" | "collections" | "resource";
export function getUser() {
  return supabaseClient.auth.user();
}

class Supabase {
  getClient() {
    return supabaseClient;
  }

  auth() {
    return this.getClient().auth;
  }

  query<T>(table: KnownTables) {
    return this.getClient().from<T>(table);
  }
}

export const supabaseWrapper = new Supabase();
